import * as React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { getPlatformNav, isNavItemActive } from "./platformNavConfig";
import { platformFonts } from "../tickitPlatformTheme";

function PlatformSidebar({ role, user }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const config = getPlatformNav(role, pathname, user);

  if (!config) return null;

  return (
    <Box
      component="aside"
      sx={{
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        width: 220,
        flexShrink: 0,
        bgcolor: "rgba(14, 5, 32, 0.6)",
        borderRight: "1px solid rgba(255,255,255,0.06)",
        py: 2.5,
        px: 1.5,
        gap: 0.5,
        minHeight: "calc(100vh - 60px)",
        position: "sticky",
        top: 60,
        alignSelf: "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 1.5,
          py: 1,
          mb: 1,
          borderRadius: "10px",
          bgcolor: "rgba(107, 45, 197, 0.15)",
          border: "1px solid rgba(107, 45, 197, 0.25)",
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: config.moduleColor || "#6B2DC5",
            flexShrink: 0,
          }}
        />
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.05em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,0.6)",
            fontFamily: platformFonts.body,
          }}
        >
          {config.moduleLabel}
        </Typography>
      </Box>

      {config.parentNav && (
        <ButtonBase
          onClick={() => navigate(config.parentNav.path)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.125,
            width: "100%",
            textAlign: "left",
            justifyContent: "flex-start",
            px: 1.25,
            py: 1.125,
            mb: 0.75,
            borderRadius: "10px",
            color: "rgba(255,255,255,0.75)",
            bgcolor: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",
            fontFamily: platformFonts.body,
            fontSize: 13,
            fontWeight: 600,
            transition: "all 0.2s",
            "&:hover": {
              color: "#fff",
              bgcolor: "rgba(107,45,197,0.22)",
              borderColor: "rgba(107,45,197,0.35)",
            },
          }}
        >
          {config.parentNav.icon && (
            <config.parentNav.icon sx={{ fontSize: 17, flexShrink: 0 }} />
          )}
          {config.parentNav.label}
        </ButtonBase>
      )}

      <Typography
        sx={{
          fontFamily: platformFonts.display,
          fontSize: 9.5,
          fontWeight: 700,
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          color: "rgba(255,255,255,0.2)",
          px: 1.25,
          py: 0.75,
        }}
      >
        Menu
      </Typography>

      {config.items.map((item) => {
        const Icon = item.icon;
        const active = isNavItemActive(pathname, item.path);
        return (
          <ButtonBase
            key={`${item.path}-${item.label}`}
            onClick={() => navigate(item.path)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.125,
              width: "100%",
              textAlign: "left",
              justifyContent: "flex-start",
              px: 1.25,
              py: 1,
              borderRadius: "10px",
              color: active ? "#fff" : "rgba(255,255,255,0.45)",
              bgcolor: active ? "rgba(107,45,197,0.38)" : "transparent",
              fontFamily: platformFonts.body,
              fontSize: 13,
              fontWeight: 500,
              transition: "all 0.2s",
              "&:hover": {
                color: "rgba(255,255,255,0.85)",
                bgcolor: active ? "rgba(107,45,197,0.38)" : "rgba(255,255,255,0.05)",
              },
            }}
          >
            <Icon sx={{ fontSize: 17, flexShrink: 0 }} />
            {item.label}
          </ButtonBase>
        );
      })}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  role: state?.auth?.token?.split(" ")[0],
  user: state?.auth?.user,
});

export default connect(mapStateToProps)(PlatformSidebar);
